import { createSelector } from 'redux-bundler'

import { minutes } from 'milliseconds'

import createListBundle from '~/src/Lib/createListBundle'
import { WasteReason as schema } from '~/src/Store/Schemas'

export const initialState = {
  search: '',
  ordering: ['name', 'asc'],
}

const { selectWasteReasonListShouldUpdate, ...initialBundle } = createListBundle({
  entityName: 'wasteReason',
  initialState,
  schema,
  fetchHandler: ({ apiFetch, params }) => apiFetch('/wasteReasons/', { ...params, pagination: 0 }),
  flags: { keys: ['METRC'] },
  staleAfter: minutes(60),
})

export default {
  ...initialBundle,
  selectWasteReasonListShouldNormallyUpdate: selectWasteReasonListShouldUpdate,
  selectWasteReasonListShouldUpdate: createSelector(
    'selectWasteReasonListShouldNormallyUpdate',
    'selectWasteReasonListRaw',
    'selectCurrentMetrcFacilities',
    'selectIsOnline',
    (shouldNormallyUpdate, { failedPermanently, lastSuccess, isLoading }, metrcFacilities, isOnline) => {
      if (shouldNormallyUpdate) return true

      if (!isOnline || failedPermanently || isLoading) return false

      const syncedSinceLastFetch = metrcFacilities.some(
        metrcFacility => metrcFacility.lastWasteReasonRefresh && lastSuccess < new Date(metrcFacility.lastWasteReasonRefresh)
      )
      if (syncedSinceLastFetch) {
        return true
      }

      return false
    }
  ),
}
